<template>
  <div class="history_page_wrapper">
    <Header />

    <div class="history_list_block">
      <ul class="history-listing">
       <li v-for="(item, index) in history" :key="index">
          <div class="location-pic">
            <img :src="item.user_img" v-if="item.user_img" />
            <img src="../assets/images/user_images.png" v-else />
          </div>
          <div class="history_details">
            <p>
              <span class="create_feed">
                <b class="feed_line">{{item.message}}</b>
                <b class="feed_line"></b>
              </span>
            </p>
            <span class="time"><timeago :datetime="item.time * 1000" :auto-update="60" /></span>
          </div>
        </li> 
      </ul>
       <infinite-loading @infinite="infiniteHandler()">
          <template slot="no-more">No Records available</template>
      </infinite-loading>
    </div>

    <Footer />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import types from "../store/types";
import Vue from "vue";
import VueCookie from "vue-cookie";
import InfiniteLoading from "vue-infinite-loading";
import ApiCaller from "../utils/apicaller";
import { toaster } from "../utils/helper";
Vue.use(InfiniteLoading);
Vue.use(VueCookie);
export default {
  name: "Notification",
  components: {
    Header,
    Footer,
    InfiniteLoading
  },
  data() {
    return {
      limit: 0,
      userNotification: []
    };
  },
   computed: {
    ...mapState(["history"])
  },
  methods: {
  infiniteHandler($state) {
      if (this.limit < 100) {
        ApiCaller(`/feed/notification?limit=${this.limit}`, "get").then(data => {
          if (data.length) {
            this.limit += 10;
            this.$store.commit(types.LOADUSERHISTORY, data);
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      } else {
        $state.complete();
      }
    }
  },
   async mounted() {
    // this.$store.dispatch({ type: "getNotifications" }).then(data => {
    //   this.userNotification =data;
    // });
    await this.$store.commit(types.LOADUSERHISTORY, []);
    this.infiniteHandler();
  }
};
</script>
